module.exports = __webpack_public_path__ + "img/4_158.d1a240c1.png";